module.exports = __webpack_public_path__ + "static/media/about_pic_mess03.0b8f639e.jpg";